import { AmplitudeClient } from 'amplitude-js';

export const initAmplitude = (): AmplitudeClient | undefined => {
    if (
        process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ||
        process.env.NEXT_PUBLIC_ENVIRONMENT === 'qa' ||
        process.env.NEXT_PUBLIC_ENVIRONMENT === 'staging'
    ) {
        const amplitude = require('amplitude-js');
        amplitude.getInstance().init(process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY);
        if (
            process.env.NEXT_PUBLIC_BUILD_ID &&
            process.env.NEXT_PUBLIC_ENVIRONMENT
        ) {
            amplitude
                .getInstance()
                .setVersionName(
                    process.env.NEXT_PUBLIC_BUILD_ID +
                        process.env.NEXT_PUBLIC_ENVIRONMENT
                        ? '-' + process.env.NEXT_PUBLIC_ENVIRONMENT
                        : '',
                );
        }
        return amplitude.getInstance();
    }
};
